/**
 * Discount Hooks
 */

import type { Discount, Promotion, DiscountApplicableTo } from "@/types/discount";

interface DiscountParams {
    // array of enums
    applicableTo?: DiscountApplicableTo[]
}

interface DiscountPriceChangeParams {
    discounts?: string[],
    promotion?: string,
    contractId?: string,
    packageId?: string
    productId?: string
}

export const fetchPriceChanges = async (params?: DiscountPriceChangeParams) => {
    try {
        let url = new URL(`${process.env.REACT_APP_API_URL}/discount/price-change`);

        if(params?.discounts) {
            url.searchParams.append('discounts', params.discounts.join(','))
        }

        if(params?.promotion) {
            url.searchParams.append('promotion', params.promotion)
        }

        if(params?.contractId) {
            url.searchParams.append('contractId', params.contractId)
        }

        if(params?.packageId) {
            url.searchParams.append('packageId', params.packageId)
        }

        if(params?.productId) {
            url.searchParams.append('productId', params.productId)
        }

        const res = await fetch(url.toString())

        const data = await res.json()

        if(!data?.success) {
            throw new Error(data?.message ?? 'Үнийн өөрчлөлтүүдийг татаж')
        }

        return data.data as {
            before: {
                type: 'recurring' | 'one-time',
                price: number,
                discount: number,
                total: number,
                description?: string
            }[],
            after: {
                type: 'recurring' | 'one-time',
                price: number,
                discount: number,
                total: number,
                description?: string
            }[],
        }
        
    } catch (error: any) {
        console.error(error)
        throw new Error(error ?? 'Үнийн өөрчлөлтүүдийг татаж чадсангүй')
    }
}

export const fetchDiscounts = async (params?: DiscountParams) => {
    try {
        let url = `${process.env.REACT_APP_API_URL}/discount`;

        if(params?.applicableTo) {
            url += `?applicableTo=${params.applicableTo.join(',')}`
        }

        const res = await fetch(url)
        const data = await res.json()

        if(!data?.success) {
            throw new Error(data?.message ?? 'Хямдралуудыг татаж чадсангүй')
        }

        return data.data as Discount[]
    } catch (error: any) {
        console.error(error)
        throw new Error(error ?? 'Хямдралуудыг татаж чадсангүй')
    }
}

export const fetchDiscount = async (discountId: string) => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/discount/${discountId}`)
        const data = await res.json()

        if(!data?.success) {
            throw new Error(data?.message ?? 'Хямдралыг татаж чадсангүй')
        }

        return data.data as Discount
    } catch (error: any) {
        console.error(error)
        throw new Error(error ?? 'Хямдралыг татаж чадсангүй')
    }
}

export const fetchPromotions = async () => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/discount/promotion`)
        const data = await res.json()

        if(!data?.success) {
            throw new Error(data?.message ?? 'Урамшууллыг татаж чадсангүй')
        }

        return data.data as Promotion[]
    } catch (error: any) {
        console.error(error)
        throw new Error(error ?? 'Урамшууллыг татаж чадсангүй')
    }
}

export const fetchPromotion = async (promotionId: string) => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/discount/promotion/${promotionId}`)
        const data = await res.json()

        if(!data?.success) {
            throw new Error(data?.message ?? 'Урамшууллыг татаж чадсангүй')
        }

        return data.data as Promotion
    } catch (error: any) {
        console.error(error)
        throw new Error(error ?? 'Урамшууллыг татаж чадсангүй')
    }
}